var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all2) => {
  __markAsModule(target);
  for (var name in all2)
    __defProp(target, name, { get: all2[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  getParserValidKeys: () => getParserValidKeys,
  isCustomFunction: () => isCustomFunction,
  taxdownMath: () => taxdownMath,
  taxdownMathParser: () => taxdownMathParser,
  translateFunction: () => translateFunction
});
var import_mathjs = __toModule(require("mathjs"));
var import_utils = __toModule(require("../../../engine/utils"));
var import_arithmetic = __toModule(require("./functions/arithmetic"));
var import_logical = __toModule(require("./functions/logical"));
var import_matrices = __toModule(require("./functions/matrices"));
var import_matrix = __toModule(require("./functions/matrix"));
var import_relational = __toModule(require("./functions/relational"));
var import_scalar = __toModule(require("./functions/scalar"));
const FUNCTION_TRANSLATE = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, import_arithmetic.ARITHMETIC_FUNCTION_TRANSLATE), import_logical.LOGICAL_FUNCTION_TRANSLATE), import_matrices.MATRICES_FUNCTION_TRANSLATE), import_matrix.MATRIX_FUNCTION_TRANSLATE), import_relational.RELATIONAL_FUNCTION_TRANSLATE), import_scalar.SCALAR_FUNCTION_TRANSLATE);
const CUSTOM_FUNCTIONS = [
  ...Object.values(import_arithmetic.default).map((fn) => fn.name),
  ...Object.values(import_logical.default).map((fn) => fn.name),
  ...Object.values(import_matrices.default).map((fn) => fn.name),
  ...Object.values(import_matrix.default).map((fn) => fn.name),
  ...Object.values(import_relational.default).map((fn) => fn.name),
  ...Object.values(import_scalar.default).map((fn) => fn.name)
];
const math = (0, import_mathjs.create)(import_mathjs.all);
math.import(import_arithmetic.default, { override: true });
math.import(import_logical.default, { override: true });
math.import(import_matrices.default, {});
math.import(import_matrix.default, {});
math.import(import_relational.default, { override: true });
math.import(import_scalar.default, { override: true });
const taxdownMath = () => {
  return math;
};
const loadUserData = (parser, keys) => {
  Object.keys(keys).forEach((key) => {
    parser.set(key, keys[key]);
  });
};
const taxdownMathParser = (keys) => {
  const parser = math.parser();
  if ((0, import_utils.isObject)(keys)) {
    loadUserData(parser, keys);
  }
  return parser;
};
const translateFunction = (operator) => {
  return FUNCTION_TRANSLATE[operator];
};
const isCustomFunction = (name) => {
  return CUSTOM_FUNCTIONS.includes(name);
};
const getParserValidKeys = (parser) => {
  const parserKeys = parser.getAll();
  Object.keys(parserKeys).forEach((key) => {
    if ((0, import_utils.isEmpty)(parserKeys[key])) {
      delete parserKeys[key];
    }
  });
  return parserKeys;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  getParserValidKeys,
  isCustomFunction,
  taxdownMath,
  taxdownMathParser,
  translateFunction
});
